function setColorSchemeDark() {
  document.documentElement.classList.remove("lightmode");
  document.documentElement.classList.add("darkmode");
  localStorage.setItem("colorScheme", "dark");
}
function setColorSchemeLight() {
  document.documentElement.classList.remove("darkmode");
  document.documentElement.classList.add("lightmode");
  localStorage.setItem("colorScheme", "light");
}
function setColorSchemeSystem() {
  if(window.matchMedia("(prefers-color-scheme: dark)").matches){
    setColorSchemeDark();
  }else{
    setColorSchemeLight();
  }
  localStorage.removeItem("colorScheme");
}

if (localStorage.getItem("colorScheme") === "dark") {
  setColorSchemeDark();
} else if (localStorage.getItem("colorScheme") === "light") {
  setColorSchemeLight();
} else {
  setColorSchemeSystem();
}
window.onload = function() {
  const lightButton = document.querySelector("#color_scheme_light");
  const darkButton = document.querySelector("#color_scheme_dark");
  if(lightButton===null) return;

  if (localStorage.getItem("colorScheme") === "dark") {
    darkButton.setAttribute("checked", "checked");
  } else if (localStorage.getItem("colorScheme") === "light") {
    lightButton.setAttribute("checked", "checked");
  }

  lightButton.addEventListener("change", () => {
    setColorSchemeLight();
  });
  darkButton.addEventListener("change", () => {
    setColorSchemeDark();
  });
}


// WEBPACK FOOTER //
// ./app/javascript/packs/darkmode.js